<template>
<v-dialog
    v-model="dialog"
    max-width="920"
>
    <v-card>
        <v-card-title>Add Recipients Who Have Not Customized Their Club Shipment</v-card-title>

        <v-card-text>
            <v-select
                label="Shipment"
                :items="items"
                v-model="shipment_id"
                hint="Only upcoming club releases may be selected"
                persistent-hint
            />
            <v-checkbox
                label="Exclude people that have put their membership on hold"
                v-model="do_not_include_hold"
            />
            <v-checkbox
                label="Exclude people that have skipped the shipment"
                v-model="do_not_include_skip"
                style="margin-top: -15px"
            />
            <v-checkbox
                label="Exclude people that have cancelled the club"
                v-model="do_not_include_cancelled"
                style="margin-top: -15px"
            />

        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
                :disabled="shipment_id == null"
            >
            Add Recipients
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,

            items: [
                { 'text': 'April 6 Bottle Club Release', 'value': '75760A13-C1B9-4018-AEB6-3A6114EBB82F'},
                { 'text': 'April 12 Bottle Club Release', 'value': 'F8C8AD74-0B93-4BE0-828F-27014A0DDB88'},
                { 'text': 'April Library Wine Club Release', 'value': '3DF8D8B1-3ACD-4A7D-B18D-1468A6B89AED'},
            ],
            shipment_id: null,
            do_not_include_hold: true,
            do_not_include_skip: true,
            do_not_include_cancelled: true,
            refresh_list_before_sending: true,
            active_releases: [],
        }
    },

    methods: {

        showDialog()
        {
            this.shipment_id = null;
            this.do_not_include_hold = true;
            this.do_not_include_skip = true;
            this.do_not_include_cancelled = true;
            this.refresh_list_before_sending = true;

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/bulk/club-release/select-active-profile/:organization_id',

                'params' : {
                        'organization_id': this.$route.params.organization_id,
                    },

                'on_success': (data) => {
                        if ( data.enabled == false )
                        {
                            this.$rc.alert('Required integration is not present', 'You do not have an integration enabled that supports adding recipients that have not customized their club');
                            return;
                        }

                        this.active_releases = data.active_releases;

                        // Create items with club name and title directly from the response
                        this.items = data.active_releases.map(item => {
                            // Use the club_name field that's now included in the response
                            if (item.club_name) {
                                return {'text': `${item.club_name} | ${item.title}`, 'value': item.club_release_id};
                            } else {
                                return {'text': item.title, 'value': item.club_release_id};
                            }
                        });

                        this.dialog = true;
                    },

                'on_error': 'Unable to list active releases',
            });

            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;

            let club_release = this.active_releases.find(item => item.club_release_id == this.shipment_id);

            this.$rc.startProcess({
                'type': 'crm-create-excel-preview-of-customers-who-have-not-customized-club-release',

                'params': {
                    'organization_id' : this.$route.params.organization_id,
                    'bulk_message_id': this.$route.params.bulk_message_id,
                    'settings_id': club_release.settings_id,
                    'content_type': club_release.content_type,
                    'club_release_id': club_release.club_release_id,
                    'do_not_include_hold': this.do_not_include_hold,
                    'do_not_include_skip': this.do_not_include_skip,
                    'do_not_include_cancelled': this.do_not_include_cancelled
                },

                'title': 'Listing customers who have not customized club release',
                'finished_button_text': 'Preview Recipients',
                'failed_button_text': 'Cancel',

                status: (pte) => {
                    return 'Customer phone numbers: '+pte.progress_counter;
                },

                on_finished: (pte) => {
                    this.$router.push({
                        'name': 'bulk-recipient-preview',
                        'params' : {
                            'organization_id' : pte.output.organization_id,
                            'bulk_message_id' : pte.output.bulk_message_id,
                            'import_id' : pte.output.import_id
                        }
                    });
                },

                on_failed: (pte) => {
                },

            });
        },

        onCancel()
        {
            this.dialog = false;
        },

        contactSupport() {
            this.$rc.contactSupport('Beta Feature (' + this.code + ')');
        },

    },
}
</script>

<style lang="scss" scoped>
</style>